import {getMarketplaceUrls} from "./getMarketplaceUrls";

export const isMarketplaceUrl = () => {
  return (
    getMarketplaceUrls()
      .some((item: string) => window.location.href.includes(item))
  )
}